// Customer-facing wording is independent of the date interval used for pricing.
export function formatLeadTime(quote, fallbackDays = null) {
  const text = quote?.lead_time_text;
  if (typeof text === 'string' && text.trim()) return text;
  const days = quote?.lead_time_days ?? fallbackDays;
  return days == null ? '—' : `${days} working days`;
}
